export interface ClientJobCardListItem {
  id?: number;
  openDate?: string;
  closeDate?: string;
  departments?: {
    id?: number;
    jobId?: number;
    departmentId?: number;
    name?: string;
  }[];

  jobEmploymentTypes?: {
    id?: number;
    jobId?: number;
    employmentTypeId?: number;
    employmentType?: string;
  }[];

  title?: string;
  positionTypes?: {
    id?: number;
    jobId?: number;
    positionTypeId?: number;
    name?: string;
  }[];

  extension?: string;

  openTimezone?: string;
  closeTimezone?: string;
  jobOffices?: {
    id?: number;
    officeId?: number;
    jobId?: number;
    name?: string;
  }[];
}

export enum JobListSortType {
  mostRecent = "most-recent",
  oldest = "oldest",
  closeDate = "close-date",
}
